export default {
  settingList: []
}
